import * as Sentry from '@sentry/react';

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    // Only send errors in production
    enabled: import.meta.env.PROD,
    // Sample 100% of errors, 10% of performance transactions
    tracesSampleRate: 0.1,
    // Don't send PII
    sendDefaultPii: false,
    integrations: [
      Sentry.replayIntegration(),
    ],
    // Session Replay — only capture on errors to stay within free tier
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    // Ignore common non-actionable errors
    ignoreErrors: [
      'ResizeObserver loop',
      'Network request failed',
      'Load failed',
      'Failed to fetch',
      'The string did not match the expected pattern',
      'Exceeded storage quota',
    ],
  });
}

export { Sentry };
